import React, {useState} from 'react';
import Helmet from 'react-helmet';
import {Button, TextField, Card, CardActions, CardContent, CardHeader} from '@material-ui/core';
import {sendForgotPasswordEmail} from 'util/Authentication';

export default function ForgotPassword(_props, context) {
  const [username, setUsername] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const handleChangeUsername = ({target: {value}}) => setUsername(value);
  const handleSubmit = async () => {
    if (username !== '') {
      try {
        await sendForgotPasswordEmail(username);
        setErrorMessage('');
      } catch (err) {
        setErrorMessage(err.message);
      }
    }
  };

  return (
    <div
      className="login_bg"
      style={{
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0% 30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Helmet title="myOzgene" defer={false} />
      <Card
        style={{
          marginTop: '20px',
          padding: '20px 20px 20px 20px',
          backgroundColor: 'white',
          width: '300px',
          zDepth: '0',
        }}
      >
        <img
          src="/ozgene_logo.png"
          alt="logo"
          width="200"
          height="60"
          style={{
            marginRight: 'auto',
            marginLeft: 'auto',
            display: 'block',
          }}
        />
        <CardHeader title="Forgot Password" />
        <CardContent style={{paddingTop: 0}}>
          <span style={{color: 'red'}}>{errorMessage}</span>
          <br />
          <span style={{fontSize: 'smaller', paddingTop: 0}}>
            Please enter your username (firstname.lastname) and click send to receive a verification
            code in your email.
          </span>
          <br />
          <TextField
            placeholder="Enter your Username"
            fullWidth
            label="Username"
            onChange={handleChangeUsername}
          />
        </CardContent>
        <CardActions>
          <Button variant="outlined" color="primary" onClick={handleSubmit}>
            Send
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}
